module.exports = __webpack_public_path__ + "static/media/Marketplace_img.4826fad9.png";